/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createAppOrder} from '../api'

export const useMutationCreateAppOrder = createReactQueryMutationHook('createAppOrder', createAppOrder)
